import { render } from "./rowSkeletor.vue?vue&type=template&id=94c57062"
const script = {}

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__